<template>
  <p>Logging you out...</p>
</template>
<script>
import { clearAuthCookies } from '../../functions.ts';

export default {
    mounted() {
        clearAuthCookies();
        this.$utils.fadeOutLoading();
        this.$router.replace( '/' );
    },
};
</script>
